/* 
PUBLIC PAGE 
*/
import React from "react";
import BusinessVerification from "../Components/BusinessVerification/BusinessVerification";
import Layout from "../Components/Layout/Layout";

function BusVerificationPage() {
  return (
    <Layout>
      <BusinessVerification />
    </Layout>
  );
}

export default BusVerificationPage;
